var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinimize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1205_1700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 18H18V28H22V18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 18V22H28V18H18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 28H10L10 18H6L6 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 18L0 22H10V18H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 0H18V10H22V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 10V6L18 6V10H28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10H10L10 0H6L6 10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10V6L0 6V10H10Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1205_1700"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimize);
export default __webpack_public_path__ + "static/media/Minimize.d0b661d8c0c38a841eb3776346c2d7b6.svg";
export { ForwardRef as ReactComponent };